addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById('iq-overlay');
    if (!overlay) return;

    const EVENT_NAME = 'iPhone Quiz';

    /* One property per event: { step: value }. Guarded so a missing/blocked
       Rybbit never throws (which would interrupt the click/navigation flow). */
    const track = (step, value) => {
        try {
            const clean = typeof value === 'string' ? value.replace(/"/g, '″') : value;
            console.log(`Rybbit event: ${EVENT_NAME} { ${step}: ${clean} }`);
            window.rybbit.event(EVENT_NAME, { [step]: clean });
        } catch (e) { }
    };

    const currentStep = () => {
        const screen = overlay.querySelector('.iq-screen:not([hidden])');
        return (screen && screen.dataset.iqStep) || 'N/A';
    };

    const valueOf = (el) => (el && el.dataset.iqValue) || 'N/A';
    const aInput = () => document.getElementById('iq-ain');

    /* Recommended product's title, falling back to its handle. */
    const productName = (el) => {
        const card = el.closest('.iq-card, .product-card, product-card');
        const title = card && card.querySelector('.title, .card__title');
        if (title) return title.textContent.replace(/\s+/g, ' ').trim();
        const link = card && card.querySelector('a[href*="/products/"]');
        return link ? link.getAttribute('href').split('?')[0].split('/products/').pop() : 'N/A';
    };

    /* selector → value; `nav` marks links that navigate away (send before following). */
    const targets = [
        { selector: '#iq-mode-quiz' },
        { selector: '#iq-mode-coll' },
        { selector: '#iq-nnx', getValue: () => { const s = overlay.querySelector('.iq-screen:not([hidden]) .iq-opt.sel'); return s ? valueOf(s) : null; } },
        { selector: '.iq-ccard' },
        { selector: '#iq-abtn', getValue: () => (aInput() || {}).value || 'N/A' },
        { selector: '.iq-cards form[action*="/cart/add"] [type="submit"]', getValue: (el) => 'Læg i kurv: ' + productName(el) },
        { selector: '.iq-cards a[href*="/products/"]', getValue: (el) => 'Vis produkt: ' + productName(el), nav: (el) => (el.closest('a') || {}).href },
        { selector: '#iq-seeall', getValue: () => 'Se hele udvalget', nav: (el) => el.href },
        { selector: '#iq-gocart', getValue: () => 'Gå til kurv', nav: (el) => el.href },
        { selector: '#iq-rst' },
        { selector: '#iq-xbtn' },
        { selector: '.iq-close-link' },
    ];

    const isPlainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

    /* Capture phase so the current screen is read before the quiz re-renders. */
    document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        for (const { selector, getValue, nav } of targets) {
            const match = event.target.closest(selector);
            if (!match || !overlay.contains(match)) continue;

            const value = (getValue || valueOf)(match);
            if (value == null) return; /* matched, but nothing to record yet */
            track(currentStep(), value);

            /* Links would abort the request on navigation — send first, then follow. */
            const url = nav && nav(match);
            if (url && isPlainClick(event)) {
                event.preventDefault();
                setTimeout(() => { window.location.href = url; }, 150);
                return;
            }

            return;
        }
    }, true);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
            track(currentStep(), 'Lukkede (Escape)');
        } else if (event.key === 'Enter' && event.target === aInput() && aInput().value.trim()) {
            /* A-number search submitted with Enter (the button click is tracked via targets). */
            track(currentStep(), aInput().value.trim());
        }
    });
});
